import {ReadAccessTypeVo} from '../../common/shared/api/nicolas/vo/enums/ReadAccessTypeVo.enum';
import {ReadAccessType} from '../generated/types';

export function createReadAccessType(
  readAccessTypeVo: ReadAccessTypeVo
): ReadAccessType {
  return mapper[readAccessTypeVo];
}

const mapper: {[key in ReadAccessTypeVo]: ReadAccessType} = {
  [ReadAccessTypeVo.NotPurchased]: ReadAccessType.NotPurchased,
  [ReadAccessTypeVo.CanRead]: ReadAccessType.CanRead,
  [ReadAccessTypeVo.CanReadSerialize]: ReadAccessType.CanReadSerialize,
  [ReadAccessTypeVo.Expired]: ReadAccessType.Expired,
  [ReadAccessTypeVo.UnreadableWeb]: ReadAccessType.UnreadableWeb,
  [ReadAccessTypeVo.UnreadableWebAgeLimit]:
    ReadAccessType.UnreadableWebAgeLimit,
};
